import React from "react";

export const CloseIcon2 = ({ strokeColor, ...props }: any) => {
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <path
        d="M3.094 3.281L9.28 9.47M3.094 9.469L9.28 3.28"
        stroke={strokeColor || "#01A8CE"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
